export const cameraScheduleSelector = state => state.entities.cameraSchedules;
